'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Ad = function (_Component) {
    (0, _inherits3.default)(Ad, _Component);

    function Ad() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Ad);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Ad.__proto__ || (0, _getPrototypeOf2.default)(Ad)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            error: false,
            adType: ''
        }, _this.onSuccess = function (_ref2) {
            var adObj = _ref2.adObj,
                rest = (0, _objectWithoutProperties3.default)(_ref2, ['adObj']);
            var adType = adObj.adType;


            _this.setState({
                error: false,
                adType: adType
            });

            if (_this.props.onSuccess) {
                _this.props.onSuccess((0, _extends3.default)({ adObj: adObj }, rest));
            }
        }, _this.onError = function (_ref3) {
            var _ref3$adObj = _ref3.adObj,
                adObj = _ref3$adObj === undefined ? {} : _ref3$adObj,
                rest = (0, _objectWithoutProperties3.default)(_ref3, ['adObj']);
            var _adObj$adType = adObj.adType,
                adType = _adObj$adType === undefined ? 'banner' : _adObj$adType;


            _this.setState({
                error: true,
                adType: adType
            });
            if (_this.props.onError) {
                _this.props.onError((0, _extends3.default)({ adObj: adObj }, rest));
            }
        }, _this.setPlacementRef = function (node) {
            _this.node = node;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Ad, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            // Only register if we have a node
            if (this.node && window.adRenderer) {
                window.adRenderer.register(this.node, {
                    onSuccess: this.onSuccess,
                    onError: this.onError
                });
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            if (this.node && window.adRenderer) {
                window.adRenderer.unregister(this.node);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                variants = _props.variants,
                priority = _props.priority,
                refresh = _props.refresh,
                subtype = _props.subtype,
                visibleOnError = _props.visibleOnError;

            // Ensure all variants have an invCode

            if (variants.some(function (variant) {
                return !variant.invCode;
            })) {
                return null;
            }

            var _state = this.state,
                error = _state.error,
                adType = _state.adType;

            var style = void 0;
            if (error && !visibleOnError) {
                style = { display: 'none' };
            }
            return _react2.default.createElement('div', {
                ref: this.setPlacementRef,
                className: (0, _classnames3.default)('ad', 'spp-ad', (0, _defineProperty3.default)({}, 'ad-type-' + adType, adType)),
                'data-variants': (0, _stringify2.default)(variants),
                'data-priority': priority,
                'data-refresh': refresh,
                'data-ad-placement': subtype,
                style: style
            });
        }
    }]);
    return Ad;
}(_react.Component); /* global window */


Ad.propTypes = {
    variants: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        invCode: _propTypes2.default.string.isRequired,
        sizes: _propTypes2.default.array,
        probableHeight: _propTypes2.default.number,
        probableWidth: _propTypes2.default.number
    })).isRequired,
    priority: _propTypes2.default.oneOf(['high', 'normal', 'low']),
    refresh: _propTypes2.default.bool,
    onSuccess: _propTypes2.default.func,
    onError: _propTypes2.default.func,
    subtype: _propTypes2.default.string.isRequired,
    visibleOnError: _propTypes2.default.bool
};
Ad.defaultProps = {
    priority: 'normal',
    refresh: false,
    visibleOnError: false,
    onSuccess: undefined,
    onError: undefined
};
exports.default = Ad;
//# sourceMappingURL=Ad.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/ad-components/lib/Ad/Ad.js
 ** module id = 263
 ** module chunks = 1
 **/